import { useState, useCallback } from 'react';
import { IOverrideState } from '../types/verify-travel.types';
import { IWatrRequestTravels } from '@nkr/models/index';

const initialOverrideState: IOverrideState = {
    isMilesOverWritten: false,
    overrideMiles: 0,
    isMealsOverWritten: false,
    overrideMeals: 0,
    isCarServiceExpenseOverridden: false,
    overrideCarServiceExpense: 0,
    isDependentCareExpenseOverridden: false,
    overrideDependentCareExpense: 0,
    isHotelLodgingExpenseOverridden: false,
    overrideHotelLodgingExpense: 0
};

export const useOverrideState = () => {
    const [overrideState, setOverrideState] = useState<IOverrideState>(initialOverrideState);

    const updateOverride = useCallback((updates: Partial<IOverrideState>) => {
        setOverrideState(prev => ({ ...prev, ...updates }));
    }, []);

    const toggleOverride = useCallback((overrideType: 'miles' | 'meals' | 'carService' | 'dependentCare' | 'lodging', currentValue: number) => {
        switch (overrideType) {
            case 'miles':
                setOverrideState(prev => {
                    const newIsOverridden = !prev.isMilesOverWritten;
                    return { 
                        ...prev, 
                        isMilesOverWritten: newIsOverridden,
                        overrideMiles: newIsOverridden ? currentValue : 0
                    };
                });
                break;
            case 'meals':
                setOverrideState(prev => {
                    const newIsOverridden = !prev.isMealsOverWritten;
                    return { 
                        ...prev, 
                        isMealsOverWritten: newIsOverridden,
                        overrideMeals: newIsOverridden ? currentValue : 0
                    };
                });
                break;
            case 'carService':
                setOverrideState(prev => {
                    const newIsOverridden = !prev.isCarServiceExpenseOverridden;
                    return { 
                        ...prev, 
                        isCarServiceExpenseOverridden: newIsOverridden,
                        overrideCarServiceExpense: newIsOverridden ? currentValue : 0
                    };
                });
                break;
            case 'dependentCare':
                setOverrideState(prev => {
                    const newIsOverridden = !prev.isDependentCareExpenseOverridden;
                    return { 
                        ...prev, 
                        isDependentCareExpenseOverridden: newIsOverridden,
                        overrideDependentCareExpense: newIsOverridden ? currentValue : 0
                    };
                });
                break;
            case 'lodging':
                setOverrideState(prev => {
                    const newIsOverridden = !prev.isHotelLodgingExpenseOverridden;
                    return { 
                        ...prev, 
                        isHotelLodgingExpenseOverridden: newIsOverridden,
                        overrideHotelLodgingExpense: newIsOverridden ? currentValue : 0
                    };
                });
                break;
        }
    }, []);

    const syncWithTravelRequest = useCallback((travelRequest: IWatrRequestTravels | undefined) => {
        if (travelRequest) {
            setOverrideState({
                isMilesOverWritten: travelRequest.isMilesOverWritten || false,
                overrideMiles: travelRequest.overrideMiles || 0,
                isMealsOverWritten: travelRequest.isMealsOverWritten || false,
                overrideMeals: travelRequest.overrideMeals || 0,
                isCarServiceExpenseOverridden: travelRequest.isCarServiceExpenseOverridden || false,
                overrideCarServiceExpense: travelRequest.overrideCarServiceExpense || 0,
                isDependentCareExpenseOverridden: travelRequest.isDependentCareExpenseOverridden || false,
                overrideDependentCareExpense: travelRequest.overrideDependentCareExpense || 0,
                isHotelLodgingExpenseOverridden: (travelRequest as any).isHotelLodgingExpenseOverridden || false,
                overrideHotelLodgingExpense: (travelRequest as any).overrideHotelLodgingExpense || 0
            });
        } else {
            setOverrideState(initialOverrideState);
        }
    }, []);

    return {
        overrideState,
        updateOverride,
        toggleOverride,
        syncWithTravelRequest,
        setOverrideState
    };
};

